import Component from '../../shared/component';

export default class CommentButton extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.resourceType = this.$element.data('resource-type');
    this.resourceId = this.$element.data('resource-id');

    this.$commentFormInput = $(
      `.commentButtonInput[data-resource-type=${this.resourceType}][data-resource-id=${this.resourceId}]`
    );

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.CommentButton', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.CommentButton', this.handleClick);
  }

  handleClick() {
    this.$commentFormInput.focus();
  }
}
